<div class="joint-configuration-wrapper" *ngIf="jointIDForm" [formGroup]="jointIDForm">
    <div class="container-fluid">
        <div class="row mt-3 mb-3">
            <div class="col-md-10">
                <div class="row">
                    <div class="col-md-6">
                        <div>
                            <mat-label>Joint ID is based on</mat-label>
                            <mat-select class="joint-id-dropdown" formControlName="jointIdType" class="dropdown-wrapper" panelClass="dropdown-wrapper">
                                <mat-option class="option-list" value="{{ item.settingValueId }}" *ngFor="let item of JointIdDropDown.setting.settingValues">{{
                                    item.value
                                }}</mat-option>
                            </mat-select>
                        </div>
                    </div>
                </div>
                <div class="row t-3 mb-3">
                    <div class="col-md-6" *ngIf="abbreviation == 'Auto'">
                        <div>
                            <mat-label>Joint ID Prefix</mat-label>
                            <mat-form-field class="example-full-width custom-text-field" floatLabel="never">
                                <input type="text" placeholder="Enter joint id prefix" formControlName="jointIDPrefix" matInput />
                            </mat-form-field>
                            <p
                                class="error-message"
                                *ngIf="jointIDForm.get('jointIDPrefix')?.errors?.pattern?.requiredPattern == '/^[a-zA-Z0-9\\-\\_\\:\\.]+$/'"
                            >
                                Joint ID Prefix can contain alphanumeric and any of the following characters: - _ : .
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
